import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from './apiDictionary';
import { getClient } from './client';

export type CalculateRecistArgs = {
  clinicalTrialId: string;
  parentTaskId: string;
  taskId: string;
};

export const calculateRecistScoring = (args: CalculateRecistArgs) => {
  const api = getClient(API_URL.readerParentTaskCalculateRecist);

  return api.put<unknown>(
    prepareUrl(API_URL.readerParentTaskCalculateRecist, [
      args.parentTaskId,
      args.taskId,
    ]),
    undefined,
    {
      headers: {
        'x-dynamika-clinical-trial-id': args.clinicalTrialId,
      },
    }
  );
};
